import { z } from 'zod'

export const GetProductTemplateProductsSchema = z.object({
    barcode: z.string().min(1),
})
